/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Spacer } from '@telus-uds/components-web';

import { addLocale, replace } from '../misc';
import request, { apiHost } from '../utils/request';
import {
  LoginContainer,
  LoginHeader,
  Title,
  Description,
  CardContainer,
  SeparatorMain,
  SeparatorText,
  LinkContainer,
  LinkText,
  LinkUrl,
  LinkWrapper
} from './css';
import { CONSTANT } from '../utils/constant';
import { useLocaleContext } from '../context/LocaleContext';

import '../../assets/css/login.css';
import '../../assets/css/login_media_queries.css';
import CustomLogin from './customLogin';

const Login = ({ history }) => {
  const queryData = new URLSearchParams(history.location.search);

  const isPasswordChangeRequired = request.getPasswordUpdate();
  const locale = useLocaleContext();
  const addLocaleToUrl = addLocale(locale);

  const {
    KEYS: { ROLES }
  } = CONSTANT;

  const getRedirectUrl = role => {
    let redirectUrl = '/';
    switch (role) {
      case ROLES.SOV_ADMIN:
      case ROLES.SOV_AGENT: {
        redirectUrl = '/orders';
        break;
      }
      case ROLES.PRODUCT_TEAM: {
        redirectUrl = '/quote-approval';
        break;
      }
      default:
        break;
    }
    return redirectUrl;
  };

  const getUserProfile = () => {
    return request.get('/users/profile');
  };

  useEffect(() => {
    const authenticate = async () => {
      const redirect = (changePassword, userProfile, url) => {
        if (changePassword) history.push(addLocaleToUrl('/update-password'));
        else if (url && url.length > 0) {
          try {
            const urlObj = JSON.parse(JSON.parse(url).url);
            history.push(
              addLocaleToUrl(
                `/${replace(urlObj.name)}/${replace(urlObj.formField.name)}/`
              )
            );
          } catch (err) {
            history.push(addLocaleToUrl(getRedirectUrl(userProfile.role.name)));
          }
        } else
          history.push(addLocaleToUrl(getRedirectUrl(userProfile.role.name)));

        window.location.reload();
      };

      //  check if user is redirected from passport with token in params
      const token = queryData.get('token');
      const changePassword = JSON.parse(
        queryData.get('changePassword') || false
      );
      const url = decodeURIComponent(queryData.get('url') || '');
      const redirectAfterLogin = localStorage.getItem('redirectAfterLogin');
      const isRedirectValid = localStorage.getItem('isRedirectValid');

      // check if already logged in
      if (request.getToken() && request.getProfile()) {
        if (isRedirectValid === 'true' && redirectAfterLogin) {
          localStorage.removeItem('redirectAfterLogin');
          localStorage.removeItem('isRedirectValid');
          history.push(redirectAfterLogin);
          window.location.reload();
        } else {
          redirect(isPasswordChangeRequired, request.getProfile(), url);
        }
      } else if (token) {
        request.setToken(token);
        request.setPasswordUpdate(changePassword);
        try {
          const { data } = await getUserProfile();
          request.setProfile(data);
          request.setSSOLoginState(true);
          if (isRedirectValid === 'true' && redirectAfterLogin) {
            localStorage.removeItem('redirectAfterLogin');
            localStorage.removeItem('isRedirectValid');
            history.push(redirectAfterLogin);
            window.location.reload();
          } else {
            redirect(changePassword, data, url);
          }
        } catch (err) {
          localStorage.clear();
        }
      } else localStorage.clear();
    };

    authenticate();
  }, [request.getToken()]);

  return (
    <>
      <LoginContainer>
        <LoginHeader>
          <Title>Welcome to Capture</Title>
          <Description>
            Please select the applicable login method from the options below.
          </Description>
        </LoginHeader>
        <Spacer space={2} />
        <CardContainer>
          <CustomLogin history={history} />
          <SeparatorMain>
            <SeparatorText>OR</SeparatorText>
          </SeparatorMain>
          <Button
            variant={{ priority: 'low', width: 'full' }}
            onPress={() =>
              window.location.replace(`${apiHost}/users/sso-login`)
            }
          >
            TELUS SSO
          </Button>
          <Button
            variant={{ priority: 'low', width: 'full' }}
            onPress={() =>
              window.location.replace(`${apiHost}/users/sso-login-partners`)
            }
          >
            Partner SSO
          </Button>
          <LinkWrapper>
            <LinkContainer>
              <LinkText>Forgot Password?</LinkText>
              <Link to="/forgot-password">
                <LinkUrl>Reset Here</LinkUrl>
              </Link>
            </LinkContainer>
            <LinkContainer>
              <LinkText>New to Capture?</LinkText>
              <Link to="/registration">
                <LinkUrl>Register Now</LinkUrl>
              </Link>
            </LinkContainer>
          </LinkWrapper>
        </CardContainer>
      </LoginContainer>
    </>
  );
};

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};
export default Login;
